import type { MCPToolset } from '@/types/MCPServer'

const isStringArray = (value: unknown): value is string[] =>
  Array.isArray(value) && value.every((item) => typeof item === 'string')

export const normalizeMCPToolset = (
  toolset: Partial<MCPToolset> | null | undefined,
): MCPToolset | null => {
  if (!toolset) return null
  if (typeof toolset.id !== 'string' || typeof toolset.name !== 'string') {
    return null
  }

  return {
    id: toolset.id,
    name: toolset.name,
    description: toolset.description ?? null,
    tools: isStringArray(toolset.tools) ? toolset.tools : [],
    enabled: Boolean(toolset.enabled),
    permissions: isStringArray(toolset.permissions) ? toolset.permissions : [],
  }
}

export const normalizeMCPToolsets = (
  toolsets: Array<Partial<MCPToolset> | null | undefined> | null | undefined,
): MCPToolset[] => {
  if (!Array.isArray(toolsets)) return []

  return toolsets.flatMap((toolset) => {
    const normalizedToolset = normalizeMCPToolset(toolset)
    return normalizedToolset ? [normalizedToolset] : []
  })
}
